// assets/ecomific-domain-prompt.js
// Non-blocking country/domain prompt driven by shopping-location state.
(function () {
  'use strict';

  if (window.__ECOMIFIC_DOMAIN_PROMPT_INIT__) {
    return;
  }
  window.__ECOMIFIC_DOMAIN_PROMPT_INIT__ = true;

  var SESSION_KEY_PREFIX = 'ecomific_domain_prompt_dismissed:';
  var SHOPPING_LOCATION_READY_EVENT = 'ecomific:shopping-location:ready';
  var SHOPPING_LOCATION_CHANGED_EVENT = 'ecomific:shopping-location:changed';
  var BOT_RE = /bot\b|crawler|spider|crawling|googlebot|adsbot-google|storebot-google|googleother|google-inspectiontool|google-adwords-instant|mediapartners-google|bingbot|bingpreview|msnbot|adidxbot|duckduckbot|slurp|baiduspider|yandexbot|applebot|semrushbot|ahrefsbot|facebookexternalhit|linkedinbot|headlesschrome|lighthouse|pagespeed|selenium|puppeteer|playwright/i;
  var CA_HOSTS = ['upsidedrinks.ca', 'www.upsidedrinks.ca'];
  var COM_HOSTS = ['upsidedrinks.com', 'www.upsidedrinks.com'];

  var promptRoot = null;
  var titleEl = null;
  var bodyEl = null;
  var stayButton = null;
  var switchButton = null;
  var activePrompt = null;
  var evaluateTimer = null;
  var mutationObserver = null;
  var Z_INDEX_CAP = 2147483647;
  var lastSyncedZIndex = null;
  var isSyncingPromptOrder = false;
  var FLAG_MARKUP = {
    CA:
      '<svg class="ecomific-domain-prompt__button-flag-svg" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation" focusable="false">' +
      '<g clip-path="url(#ecomific-flag-ca)">' +
      '<rect width="32" height="24" fill="white"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M8 0H24V24H8V0Z" fill="#F7FCFF"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9764 7L16 19H15.4005L15.7683 16.0303C13.0782 16.5144 11.8443 16.6343 12.0667 16.3902C12.2891 16.146 12.4644 15.8 12.5925 15.3521L9 12.9553C9.37779 12.9506 9.72035 12.8568 10.0277 12.674C10.335 12.4912 10.1814 11.8578 9.56668 10.7737L11.3805 11.0376L12.0667 10.2918L13.4352 11.7241H14.0503L13.4352 8.44343L14.5378 9.05932L15.9764 7ZM15.9764 7L17.4622 9.05932L18.5648 8.44343L17.9497 11.7241H18.5648L19.9333 10.2918L20.6195 11.0376L22.4333 10.7737C21.8186 11.8578 21.665 12.4912 21.9723 12.674C22.2796 12.8568 22.6222 12.9506 23 12.9553L19.4075 15.3521C19.5356 15.8 19.7109 16.146 19.9333 16.3902C20.1557 16.6343 18.9218 16.5144 16.2317 16.0303L16.5995 19H16L15.9764 7Z" fill="#E31D1C"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M24 0H32V24H24V0Z" fill="#E31D1C"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H8V24H0V0Z" fill="#E31D1C"/>' +
      '</g>' +
      '<defs><clipPath id="ecomific-flag-ca"><rect width="32" height="24" fill="white"/></clipPath></defs>' +
      '</svg>',
    US:
      '<svg class="ecomific-domain-prompt__button-flag-svg" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation" focusable="false">' +
      '<g clip-path="url(#ecomific-flag-us)">' +
      '<rect width="32" height="24" fill="white"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H32V24H0V0Z" fill="#F7FCFF"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 14.6667V16.6667H32V14.6667H0Z" fill="#E31D1C"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 18.3333V20.3333H32V18.3333H0Z" fill="#E31D1C"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.33331V9.33331H32V7.33331H0Z" fill="#E31D1C"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 22V24H32V22H0Z" fill="#E31D1C"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 11V13H32V11H0Z" fill="#E31D1C"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V2H32V0H0Z" fill="#E31D1C"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 3.66669V5.66669H32V3.66669H0Z" fill="#E31D1C"/>' +
      '<rect width="20" height="13" fill="#2E42A5"/>' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M1.72203 2.93864L0.996148 3.44753L1.24121 2.54192L0.596497 1.96801H1.43858L1.72101 1.22894L2.05218 1.96801H2.77004L2.206 2.54192L2.42437 3.44753L1.72203 2.93864ZM5.72203 2.93864L4.99615 3.44753L5.24121 2.54192L4.5965 1.96801H5.43858L5.72101 1.22894L6.05218 1.96801H6.77004L6.206 2.54192L6.42437 3.44753L5.72203 2.93864ZM8.99615 3.44753L9.72203 2.93864L10.4244 3.44753L10.206 2.54192L10.77 1.96801H10.0522L9.72101 1.22894L9.43858 1.96801H8.5965L9.24121 2.54192L8.99615 3.44753ZM13.722 2.93864L12.9961 3.44753L13.2412 2.54192L12.5965 1.96801H13.4386L13.721 1.22894L14.0522 1.96801H14.77L14.206 2.54192L14.4244 3.44753L13.722 2.93864ZM0.996148 7.44753L1.72203 6.93864L2.42437 7.44753L2.206 6.54192L2.77004 5.96801H2.05218L1.72101 5.22894L1.43858 5.96801H0.596497L1.24121 6.54192L0.996148 7.44753ZM5.72203 6.93864L4.99615 7.44753L5.24121 6.54192L4.5965 5.96801H5.43858L5.72101 5.22894L6.05218 5.96801H6.77004L6.206 6.54192L6.42437 7.44753L5.72203 6.93864ZM8.99615 7.44753L9.72203 6.93864L10.4244 7.44753L10.206 6.54192L10.77 5.96801H10.0522L9.72101 5.22894L9.43858 5.96801H8.5965L9.24121 6.54192L8.99615 7.44753ZM13.722 6.93864L12.9961 7.44753L13.2412 6.54192L12.5965 5.96801H13.4386L13.721 5.22894L14.0522 5.96801H14.77L14.206 6.54192L14.4244 7.44753L13.722 6.93864ZM0.996148 11.4475L1.72203 10.9386L2.42437 11.4475L2.206 10.5419L2.77004 9.96801H2.05218L1.72101 9.22894L1.43858 9.96801H0.596497L1.24121 10.5419L0.996148 11.4475ZM5.72203 10.9386L4.99615 11.4475L5.24121 10.5419L4.5965 9.96801H5.43858L5.72101 9.22894L6.05218 9.96801H6.77004L6.206 10.5419L6.42437 11.4475L5.72203 10.9386ZM8.99615 11.4475L9.72203 10.9386L10.4244 11.4475L10.206 10.5419L10.77 9.96801H10.0522L9.72101 9.22894L9.43858 9.96801H8.5965L9.24121 10.5419L8.99615 11.4475ZM13.722 10.9386L12.9961 11.4475L13.2412 10.5419L12.5965 9.96801H13.4386L13.721 9.22894L14.0522 9.96801H14.77L14.206 10.5419L14.4244 11.4475L13.722 10.9386ZM16.9961 3.44753L17.722 2.93864L18.4244 3.44753L18.206 2.54192L18.77 1.96801H18.0522L17.721 1.22894L17.4386 1.96801H16.5965L17.2412 2.54192L16.9961 3.44753ZM17.722 6.93864L16.9961 7.44753L17.2412 6.54192L16.5965 5.96801H17.4386L17.721 5.22894L18.0522 5.96801H18.77L18.206 6.54192L18.4244 7.44753L17.722 6.93864ZM16.9961 11.4475L17.722 10.9386L18.4244 11.4475L18.206 10.5419L18.77 9.96801H18.0522L17.721 9.22894L17.4386 9.96801H16.5965L17.2412 10.5419L16.9961 11.4475ZM3.72203 4.93864L2.99615 5.44753L3.24121 4.54192L2.5965 3.96801H3.43858L3.72101 3.22894L4.05218 3.96801H4.77004L4.206 4.54192L4.42437 5.44753L3.72203 4.93864ZM6.99615 5.44753L7.72203 4.93864L8.42437 5.44753L8.206 4.54192L8.77004 3.96801H8.05218L7.72101 3.22894L7.43858 3.96801H6.5965L7.24121 4.54192L6.99615 5.44753ZM11.722 4.93864L10.9961 5.44753L11.2412 4.54192L10.5965 3.96801H11.4386L11.721 3.22894L12.0522 3.96801H12.77L12.206 4.54192L12.4244 5.44753L11.722 4.93864ZM2.99615 9.44753L3.72203 8.93864L4.42437 9.44753L4.206 8.54192L4.77004 7.96801H4.05218L3.72101 7.22894L3.43858 7.96801H2.5965L3.24121 8.54192L2.99615 9.44753ZM7.72203 8.93864L6.99615 9.44753L7.24121 8.54192L6.5965 7.96801H7.43858L7.72101 7.22894L8.05218 7.96801H8.77004L8.206 8.54192L8.42437 9.44753L7.72203 8.93864ZM10.9961 9.44753L11.722 8.93864L12.4244 9.44753L12.206 8.54192L12.77 7.96801H12.0522L11.721 7.22894L11.4386 7.96801H10.5965L11.2412 8.54192L10.9961 9.44753ZM15.722 4.93864L14.9961 5.44753L15.2412 4.54192L14.5965 3.96801H15.4386L15.721 3.22894L16.0522 3.96801H16.77L16.206 4.54192L16.4244 5.44753L15.722 4.93864ZM14.9961 9.44753L15.722 8.93864L16.4244 9.44753L16.206 8.54192L16.77 7.96801H16.0522L15.721 7.22894L15.4386 7.96801H14.5965L15.2412 8.54192L14.9961 9.44753Z" fill="#F7FCFF"/>' +
      '</g>' +
      '<defs><clipPath id="ecomific-flag-us"><rect width="32" height="24" fill="white"/></clipPath></defs>' +
      '</svg>',
  };

  function getHost() {
    return ((window.location && window.location.hostname) || '').toLowerCase();
  }

  function isBot() {
    var ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    return BOT_RE.test(ua);
  }

  function isAdLanding() {
    if (typeof window === 'undefined' || !window.location || !window.location.search) return false;
    try {
      var params = new URLSearchParams(window.location.search);
      if (
        params.has('gclid') ||
        params.has('gbraid') ||
        params.has('wbraid') ||
        params.has('gad_source') ||
        params.has('msclkid')
      ) {
        return true;
      }

      var source = String(params.get('utm_source') || '').toLowerCase();
      var medium = String(params.get('utm_medium') || '').toLowerCase();
      return source === 'google' || source === 'google_ads' || source === 'googleads' || medium === 'cpc' || medium === 'ppc';
    } catch (e) {
      return false;
    }
  }

  function isSupportedHost() {
    var host = getHost();
    return CA_HOSTS.indexOf(host) !== -1 || COM_HOSTS.indexOf(host) !== -1;
  }

  function isFrenchPage() {
    var lang = (document.documentElement && document.documentElement.lang) || '';
    if (String(lang).toLowerCase().indexOf('fr') === 0) return true;
    return String(window.location.pathname || '').indexOf('/fr') === 0;
  }

  function getShoppingLocationApi() {
    return window.ecomificShoppingLocation && window.ecomificShoppingLocation.initialized
      ? window.ecomificShoppingLocation
      : null;
  }

  function readSessionValue(key) {
    try {
      return window.sessionStorage ? window.sessionStorage.getItem(key) : null;
    } catch (e) {
      return null;
    }
  }

  function writeSessionValue(key, value) {
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(key, value);
      }
    } catch (e) {}
  }

  function buildPromptState() {
    var api = getShoppingLocationApi();
    if (!api || !isSupportedHost()) return null;

    var host = getHost();
    var location = api.getLocation();
    if (!location) return null;

    if (CA_HOSTS.indexOf(host) !== -1 && location === 'US') {
      return {
        key: 'ca:US',
        location: 'US',
        currentDomain: 'UpsideDrinks.ca',
        targetDomain: 'UpsideDrinks.com',
      };
    }

    if (COM_HOSTS.indexOf(host) !== -1 && location !== 'US') {
      return {
        key: 'com:' + location,
        location: location,
        currentDomain: 'UpsideDrinks.com',
        targetDomain: 'UpsideDrinks.ca',
      };
    }

    return null;
  }

  function isDismissed(prompt) {
    return !!readSessionValue(SESSION_KEY_PREFIX + prompt.key);
  }

  function rememberDismissal(prompt) {
    writeSessionValue(SESSION_KEY_PREFIX + prompt.key, '1');
  }

  function getCopy(prompt) {
    var currentFlag = prompt.currentDomain === 'UpsideDrinks.ca' ? 'CA' : 'US';
    var targetFlag = prompt.targetDomain === 'UpsideDrinks.ca' ? 'CA' : 'US';

    if (isFrenchPage()) {
      return prompt.location === 'US'
        ? {
            eyebrow: 'Choix du site',
            title: 'Vous magasinez depuis les États-Unis ?',
            body: 'Restez sur ' + prompt.currentDomain + ' ou passez à ' + prompt.targetDomain + ' pour continuer sur le site américain.',
            stay: 'Rester sur ' + prompt.currentDomain,
            go: 'Aller vers ' + prompt.targetDomain,
            stayFlag: currentFlag,
            goFlag: targetFlag,
          }
        : {
            eyebrow: 'Choix du site',
            title: 'Vous magasinez depuis le Canada ?',
            body: 'Restez sur ' + prompt.currentDomain + ' ou passez à ' + prompt.targetDomain + ' pour continuer sur le site canadien.',
            stay: 'Rester sur ' + prompt.currentDomain,
            go: 'Aller vers ' + prompt.targetDomain,
            stayFlag: currentFlag,
            goFlag: targetFlag,
          };
    }

    return prompt.location === 'US'
      ? {
          eyebrow: 'Choose Your Site',
          title: 'Shopping from the United States?',
          body: 'Stay on ' + prompt.currentDomain + ' or switch to ' + prompt.targetDomain + ' to continue on the US site.',
          stay: 'Stay on ' + prompt.currentDomain,
          go: 'Go to ' + prompt.targetDomain,
          stayFlag: currentFlag,
          goFlag: targetFlag,
        }
      : {
          eyebrow: 'Choose Your Site',
          title: 'Shopping from Canada?',
          body: 'Stay on ' + prompt.currentDomain + ' or switch to ' + prompt.targetDomain + ' to continue on the Canadian site.',
          stay: 'Stay on ' + prompt.currentDomain,
          go: 'Go to ' + prompt.targetDomain,
          stayFlag: currentFlag,
          goFlag: targetFlag,
        };
  }

  function buttonMarkup(flag, label) {
    return (
      '<span class="ecomific-domain-prompt__button-flag" aria-hidden="true">' + (FLAG_MARKUP[flag] || '') + '</span>' +
      '<span class="ecomific-domain-prompt__button-label">' + label + '</span>'
    );
  }

  function closePrompt(remember) {
    if (!promptRoot || !activePrompt) return;
    if (remember) {
      rememberDismissal(activePrompt);
    }
    promptRoot.classList.remove('is-visible');
    promptRoot.setAttribute('hidden', 'hidden');
    activePrompt = null;
    lastSyncedZIndex = null;
  }

  function scheduleEvaluate(delay) {
    if (evaluateTimer) {
      window.clearTimeout(evaluateTimer);
    }
    evaluateTimer = window.setTimeout(function () {
      evaluateTimer = null;
      evaluatePrompt();
    }, typeof delay === 'number' ? delay : 250);
  }

  function isVisibleElement(element) {
    if (!element || element.nodeType !== 1) return false;
    var style = window.getComputedStyle(element);
    if (!style || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity || '1') === 0) {
      return false;
    }

    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function hasModalSemantics(element) {
    if (!element || element.nodeType !== 1) return false;
    if (element.classList.contains('modal--is-active')) return true;
    if (element.getAttribute('aria-modal') === 'true') return true;

    var role = (element.getAttribute('role') || '').toLowerCase();
    if (role === 'dialog' || role === 'alertdialog') return true;

    var className = (element.className && String(element.className).toLowerCase()) || '';
    var id = (element.id && String(element.id).toLowerCase()) || '';
    return /modal|popup|overlay|lightbox/.test(className) || /modal|popup|overlay|lightbox/.test(id);
  }

  function isLargeOverlay(element) {
    if (!isVisibleElement(element)) return false;

    var style = window.getComputedStyle(element);
    var position = style.position;
    if (position !== 'fixed' && position !== 'absolute' && position !== 'sticky') {
      return false;
    }

    var rect = element.getBoundingClientRect();
    var minWidth = Math.min(window.innerWidth * 0.5, 360);
    var minHeight = Math.min(window.innerHeight * 0.35, 260);
    if (rect.width < minWidth || rect.height < minHeight) {
      return false;
    }

    var zIndex = parseInt(style.zIndex || '0', 10);
    return hasModalSemantics(element) || zIndex >= 1000;
  }

  function getCompetingOverlays() {
    if (!document.body) return [];
    var candidates = document.querySelectorAll(
      '.modal--is-active, [aria-modal="true"], [role="dialog"], [class*="modal"], [id*="modal"], [class*="popup"], [id*="popup"], iframe'
    );
    var overlays = [];

    for (var i = 0; i < candidates.length; i += 1) {
      var element = candidates[i];
      if (!element || element === promptRoot) continue;
      if (promptRoot && promptRoot.contains(element)) continue;
      if (element.closest && promptRoot && element.closest('.ecomific-domain-prompt')) continue;
      if (isLargeOverlay(element)) overlays.push(element);
    }

    return overlays;
  }

  function syncPromptZIndex() {
    if (!promptRoot) return;

    var overlays = getCompetingOverlays();
    var maxZIndex = 1200;

    for (var i = 0; i < overlays.length; i += 1) {
      var style = window.getComputedStyle(overlays[i]);
      var zIndex = parseInt(style.zIndex || '0', 10);
      if (!isNaN(zIndex)) {
        maxZIndex = Math.max(maxZIndex, zIndex);
      }
    }

    var targetZIndex = Math.min(maxZIndex + 1, Z_INDEX_CAP);
    if (lastSyncedZIndex !== targetZIndex) {
      promptRoot.style.zIndex = String(targetZIndex);
      lastSyncedZIndex = targetZIndex;
    }

    if (
      targetZIndex === Z_INDEX_CAP &&
      promptRoot.parentNode === document.body &&
      document.body.lastElementChild !== promptRoot &&
      !isSyncingPromptOrder
    ) {
      isSyncingPromptOrder = true;
      document.body.appendChild(promptRoot);
      window.setTimeout(function () {
        isSyncingPromptOrder = false;
      }, 0);
    }
  }

  function ensurePrompt() {
    if (promptRoot) return;

    promptRoot = document.createElement('div');
    promptRoot.className = 'ecomific-domain-prompt';
    promptRoot.setAttribute('hidden', 'hidden');
    promptRoot.innerHTML =
      '<div class="ecomific-domain-prompt__backdrop" data-ecomific-domain-prompt-close></div>' +
      '<div class="ecomific-domain-prompt__dialog" role="dialog" aria-modal="false" aria-labelledby="ecomific-domain-prompt-title">' +
      '  <button type="button" class="ecomific-domain-prompt__close" aria-label="Close" data-ecomific-domain-prompt-close>&times;</button>' +
      '  <div class="ecomific-domain-prompt__eyebrow" data-ecomific-domain-prompt-eyebrow></div>' +
      '  <h2 class="ecomific-domain-prompt__title" id="ecomific-domain-prompt-title" data-ecomific-domain-prompt-title></h2>' +
      '  <p class="ecomific-domain-prompt__body" data-ecomific-domain-prompt-body></p>' +
      '  <div class="ecomific-domain-prompt__actions">' +
      '    <button type="button" class="ecomific-domain-prompt__button ecomific-domain-prompt__button--secondary" data-ecomific-domain-prompt-stay></button>' +
      '    <button type="button" class="ecomific-domain-prompt__button ecomific-domain-prompt__button--primary" data-ecomific-domain-prompt-switch></button>' +
      '  </div>' +
      '</div>';

    document.body.appendChild(promptRoot);

    titleEl = promptRoot.querySelector('[data-ecomific-domain-prompt-title]');
    bodyEl = promptRoot.querySelector('[data-ecomific-domain-prompt-body]');
    stayButton = promptRoot.querySelector('[data-ecomific-domain-prompt-stay]');
    switchButton = promptRoot.querySelector('[data-ecomific-domain-prompt-switch]');
    var eyebrowEl = promptRoot.querySelector('[data-ecomific-domain-prompt-eyebrow]');

    promptRoot.addEventListener('click', function (event) {
      if (event.target && event.target.hasAttribute('data-ecomific-domain-prompt-close')) {
        closePrompt(true);
      }
    });

    document.addEventListener('keydown', function (event) {
      if ((event.key === 'Escape' || event.key === 'Esc') && activePrompt) {
        closePrompt(true);
      }
    });

    stayButton.addEventListener('click', function () {
      closePrompt(true);
    });

    switchButton.addEventListener('click', function () {
      var api = getShoppingLocationApi();
      if (!api || !activePrompt) return;
      api.selectLocation(activePrompt.location);
    });

    promptRoot._eyebrowEl = eyebrowEl;
  }

  function openPrompt(prompt) {
    if (!prompt || isDismissed(prompt)) return;
    ensurePrompt();

    activePrompt = prompt;
    var copy = getCopy(prompt);
    promptRoot._eyebrowEl.textContent = copy.eyebrow;
    titleEl.textContent = copy.title;
    bodyEl.textContent = copy.body;
    stayButton.innerHTML = buttonMarkup(copy.stayFlag, copy.stay);
    switchButton.innerHTML = buttonMarkup(copy.goFlag, copy.go);
    syncPromptZIndex();
    promptRoot.removeAttribute('hidden');
    promptRoot.classList.add('is-visible');
  }

  function evaluatePrompt() {
    if (isBot() || isAdLanding() || !isSupportedHost()) return;
    var prompt = buildPromptState();
    if (!prompt) {
      closePrompt(false);
      return;
    }
    openPrompt(prompt);
  }

  function installObserver() {
    if (mutationObserver || !document.body || typeof MutationObserver === 'undefined') return;

    mutationObserver = new MutationObserver(function () {
      if (isSyncingPromptOrder) return;
      if (activePrompt) {
        syncPromptZIndex();
        return;
      }
      scheduleEvaluate(250);
    });

    mutationObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
      childList: true,
      subtree: true,
    });
  }

  window.addEventListener(SHOPPING_LOCATION_READY_EVENT, function () {
    scheduleEvaluate(250);
  });

  window.addEventListener(SHOPPING_LOCATION_CHANGED_EVENT, function () {
    scheduleEvaluate(0);
  });

  if (document.readyState === 'complete') {
    installObserver();
    scheduleEvaluate(250);
  } else {
    window.addEventListener('load', function () {
      installObserver();
      scheduleEvaluate(250);
    });
  }
})();
